/**
 * Tipo condicional: CNPJ (14 dígitos) ou código GSNet (alfanumérico, 1-10 chars).
 * Quando #type === 'L' (Local), valida como código GSNet.
 * Caso contrário, valida como CNPJ.
 * Usado no cadastro de clientes para atender SESSP/GSNet (MT-59A4923).
 */
const CNPJ_REGEX = /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/;
const GSNET_REGEX = /^[A-Za-z0-9]{1,10}$/;

export default function (formSelector = '#customer') {
	return {
		regex: /^([A-Za-z0-9]{1,10}|(\d{2})(\d{3})(\d{3})(\d{4})(\d{2}))$/,
		filter: /[.\/\-\s]/g,
		store_mask(match, p1) {
			return p1 || '';
		},
		display_mask: '$1',
		checkValue(value = this.getValue()) {
			const form = document.querySelector(formSelector);
			const typeEl = form?.querySelector('#type');
			const type = (typeEl?.value ?? '').trim().toUpperCase();
			const isLocal = type === 'L' || type === 'LOCAL';
			const cleaned = String(value ?? '').replace(this.filter, '').trim();
			if (isLocal) {
				return cleaned.length > 0 && GSNET_REGEX.test(cleaned);
			}
			return CNPJ_REGEX.test(cleaned);
		},
		format(value = this.getValue(), mask = this.display_mask) {
			if (value == null || value === '') return '';
			const form = document.querySelector(formSelector);
			const typeEl = form?.querySelector('#type');
			const type = (typeEl?.value ?? '').trim().toUpperCase();
			const isLocal = type === 'L' || type === 'LOCAL';
			const cleaned = String(value).replace(this.filter, '').trim();
			if (isLocal) {
				return this.checkValue(value) ? cleaned : '';
			}
			return this.checkValue(value)
				? cleaned.replace(CNPJ_REGEX, '$1.$2.$3/$4-$5')
				: '';
		}
	};
}
